export * from "./issue-points-modal.component";
